<template>
  <section class="py-12 overflow-hidden md:py-20 lg:py-24" :class="backgroundClass">
    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <svg
          class="absolute bottom-0 right-0 transform translate-x-1/2 mb-48 text-gray-700 lg:top-0 lg:mt-28 lg:mb-0 xl:transform-none xl:translate-x-0"
          width="404" height="404" fill="none" viewBox="0 0 404 404" role="img" aria-labelledby="svg-workcation">
        <defs>
          <pattern id="ad119f34-7694-4c31-947f-5c9d249b21f3" x="0" y="0" width="20" height="20"
                   patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor"/>
          </pattern>
        </defs>
        <rect width="404" height="404" fill="url(#ad119f34-7694-4c31-947f-5c9d249b21f3)"/>
      </svg>

      <div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center">
            <h2 v-motion-pop-visible-once class="text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
              {{ __('What our customers say') }}
            </h2>
            <p v-motion-pop-visible-once class="mt-4 text-xl text-gray-600">
              {{ __('Our customers trust us! Soon you too?') }}
            </p>
          </div>
        </div>
      </div>

      <carousel :autoplay="8000" :transition="800" wrap-around="true" pauseAutoplayOnHover="true" v-if="testimonials && testimonials.length >= 1">
        <slide v-for="(testimonial, index) in getTestimonials" :key="index">
          <blockquote class="mt-14">
            <div class="max-w-3xl mx-auto text-center text-2xl leading-9 font-medium text-gray-900 tracking-wide">
              <p v-motion-pop-visible>
                &ldquo;{{ testimonial.review }}&rdquo;
              </p>
            </div>
            <footer class="mt-8">
              <div class="md:flex md:items-center md:justify-center">
                <!--                                            <div v-motion-pop-visible-once class="md:flex-shrink-0" v-if="testimonial.author_photo_url">-->
                <!--                                                <img class="mx-auto h-10 w-10 rounded-full" :src="testimonial.author_photo_url" alt="" />-->
                <!--                                            </div>-->
                <div class="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                  <div v-motion-pop-visible-once class="text-base font-medium text-gray-900">
                    {{ testimonial.author_name }}
                  </div>

                  <svg v-motion-pop-visible-once class="hidden md:block mx-1 h-5 w-5 text-gray-500"
                       fill="currentColor" viewBox="0 0 20 20">
                    <path d="M11 0h3L9 20H6l5-20z"/>
                  </svg>

                  <div v-motion-pop-visible-once class="text-base font-medium text-gray-500 flex items-center">
                    <StarIcon class="h-5 w-5"
                              :class="{'text-yellow-400': testimonial.rating_value >= star, 'text-gray-300': testimonial.rating_value < star}"
                              v-for="star in [1,2,3,4,5]" aria-hidden="true"/>
                  </div>
                </div>
              </div>
            </footer>
          </blockquote>
        </slide>
      </carousel>
    </div>
  </section>
</template>

<script>
import {getActiveLanguage} from "laravel-vue-i18n";
import {StarIcon} from '@heroicons/vue/solid'
import {Carousel, Slide} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

export default {
  name: "Testimonials",
  components: {
    Carousel,
    Slide,
    StarIcon,
  },
  props: {
    backgroundClass: {
      type: String,
      default: 'bg-gray-100',
    },
  },
  data() {
    return {
      testimonials: [],
    }
  },
  mounted() {
    this.loadTestimonials();
  },
  computed: {
    getTestimonials() {
      return this.testimonials;
    },
  },
  methods: {
    loadTestimonials() {
      axios.get(route('testimonials', {lang: getActiveLanguage()})).then(res => res.data).then(tm => this.testimonials = tm)
    }
  },
}
</script>